/**
 * Edit Context Variable controller
 */

import * as contextVariableService from '../../data/services/contextVariableService';

/**
 * Update an existing context variable
 * @param {string} id - Context variable ID
 * @param {Object} updates - Updates to apply
 * @param {string} updates.title - Title
 * @param {string} updates.context - Context text
 * @param {boolean} updates.isGlobal - Whether it's global
 * @returns {Promise<Object>} Updated context variable
 */
export const editContextVariable = async (id, updates) => {
  try {
    const contextVariable = await contextVariableService.updateContextVariable(id, updates);
    return contextVariable.toJSON();
  } catch (error) {
    console.error('Error editing context variable:', error);
    throw error;
  }
};

